// extracted by mini-css-extract-plugin
export default {"VisionCircle":"VisionCircle_VisionCircle__Hcc1f"};